import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router'; 
import { ApiService } from '@app/utility/api.service'; 
import { UtilService } from '@app/utility/util.service'; 
import { timer } from 'rxjs/observable/timer' 

@Component({
  selector: 'app-singlegatewaywait2',
  templateUrl: './singlegatewaywait2.component.html',
  styleUrls: ['./singlegatewaywait2.component.scss']
})
export class Singlegatewaywait2Component implements OnInit {

  
  _subscription: any
  
  PortalUser: any;
  Contact: any;
  abc2: any;
  abc: any;
  ref_id: string = ""
  
  timeLeft: number = 3600; 
  message: string = ""

  constructor(private router: Router, 
    private Util: UtilService,
    private Api: ApiService ) {
    }

  ngOnInit() { 
    let btn = document.querySelector('.btn');

    btn.addEventListener('click', function () { console.log("a")
        });
    this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal")); 
    this.InvestigateAndAppealCondition(this.PortalUser.contactid);
    this.startTimer();
    this.startTimer2();
    
  }

  async InvestigateAndAppealCondition(UID: any) {
    let thisTs = this;
    if (!this.Util.IsNullOrUndefined(UID)) {
      let drosWeb = ''
      let result: any = await this.Api.postCustomApi("SingleGateway", "GetRefID", { UID }); 
      if(!this.Util.IsNullOrUndefined(result) && result.length > 0  )
      {
        if (!this.Util.IsNullOrUndefined(result[0].authorizationUrl)) 
        {  
          drosWeb = result[0].authorizationUrl;
          sessionStorage.setItem("referenceId", result[0].referenceId)     
          this.ref_id = result[0].referenceId;
          window.open(drosWeb, "_blank");
        }
        else 
        {
          this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
          thisTs.router.navigate(["mainmenu/index"]);
        }
      }
      else 
      {
        this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
        thisTs.router.navigate(["mainmenu/index"]);
         
      }
    }
    else  {
      this.Util.WarningDialog("ไม่สามารถเชื่อมต่อกับระบบ Single GateWay ได้ กรุณาลองใหม่อีกครั้ง");
      thisTs.router.navigate(["mainmenu/index"]);
       
    }
  }
 

  async startTimer() { 
    const source = timer(1000, 2000);
    this.abc = source.subscribe(val => { 
      if(val < 3600)
      {
        this.message = this.dhms(this.timeLeft - val);
      }
      else
      {
        let thisTs = this;
        this.Util.WarningDialog("ท่านไม่ได้ทำรายการในเวลาที่กำหนด กรุณาเข้าระบบใหม่อีกครั้งหลังจากทำการยืนยันตัวตนเสร็จสิ้น");
        thisTs.router.navigate(["mainmenu/index"]);
      }
    }); 
  }

  async startTimer2() { 
    const source2 = timer(3000, 6000);
    this.abc2 = source2.subscribe(val => {   
      if(this.ref_id != "")
      {
        let para = "refId=" + this.ref_id
        this.Api.get("crmservice", "GetSingleGatewayLog", para).then((ContactRes: any) => {
         if (ContactRes.dpa_result !== undefined) 
         {
              if(ContactRes.dpa_result == 'Y')
              {
                let thisTs = this;
                this.Util.SuccessDialog("ท่านได้ทำการยืนยันตัวตนสำเร็จ");  
                thisTs.router.navigate(["mainmenu/refundDeposits"]);
              }
              else if(ContactRes.dpa_result == 'N')
              {
                let thisTs = this;
                this.Util.ErrorDialog("ท่านทำการยืนยันตัวตนไม่สำเร็จ กรุณาทำการยืนยันตัวตนอีกครั้ง โดยใช้หมายเลขบัตรประชาชน หรือหมายเลขโทรศัพท์ที่ท่านได้ทำการลงทะเบียนไว้");  
                thisTs.router.navigate(["mainmenu/refundDeposits"]);
              }
          }
            
        });
  
      }
      
      let btn = document.querySelector('.btn'); 
      let clickEvent = new Event('click');
      btn.dispatchEvent(clickEvent);

        });

  }
  
  dhms(t: number){
    var    minutes, seconds;  
    minutes = Math.floor(t / 60) % 60;
    t -= minutes * 60;
    seconds = t % 60;
    return [  
            minutes + ' นาที',
            seconds + ' วินาที'
           ].join(' ');
 }


  ngOnDestroy(){
    //prevent memory leak when component destroyed
    this.abc.unsubscribe();
    this.abc2.unsubscribe();
  }


}



// WEBPACK FOOTER //
// ./src/app/singlegatewaywait2/singlegatewaywait2.component.ts